import axios from 'axios';

const createConversation = conversation => {
  return axios.post(`conversations/builder`, conversation);
};

const createConversationAutoGenerate = prompt => {
  return axios.post(`conversations/builder/import/generate`, {
    prompt
  });
}

const deleteConversation = id => axios.delete(`conversations/builder/${id}`);

const toggleConversationLock = ({ id, locked }) => {
  return axios.put(`conversations/builder/${id}/toggleLocked`, {
    locked
  });
};

export { createConversation, createConversationAutoGenerate, deleteConversation, toggleConversationLock };
